import { NoMisalignmentBox } from '@upright/ui/common/upright/core/impact-lenses/sdg/data-area/no-misalignment-box';

export function NoAlignmentBoxes() {
  return <NoMisalignmentBox />;
}
